import { authStore } from "@/store/auth";
import { VALID_PRODUCT_SLUGS } from "@/types/Master";
import { NavigationGuard } from "vue-router";

export const setProduct: NavigationGuard = (to, _from, next) => {
  const productSlug = to.query.product as string;

  // product クエリパラメータが存在し、有効な値なら切り替える
  if (productSlug && VALID_PRODUCT_SLUGS.includes(productSlug)) {
    authStore.changeProduct(productSlug);
  }

  next();
};
